/**
 * Cherocarouselcontrols Component
 * Navigation controls for hero carousel with equip team and build your own team options
 */
'use client';
import type { CSSProperties, ReactElement } from 'react';
import { useViewport } from '@/hooks/dom';
import { BuildAllControls } from './BuildAllControls';
import { CarouselArrowControl, CarouselArrowControlDirection } from './CarouselArrowControl';
import { CONTROLS_ANIMATION, type HeroCarouselControlsAnimationEventHandler, TOP_ROW_GAP_BY_VIEWPORT, resolveHeroCarouselControlsViewport, } from './Cherocarouselcontrols.constants';
import { DeployInspectControl } from './DeployInspectControl';
export interface CherocarouselcontrolsProps {
    onPrevious?: () => void;
    onNext?: () => void;
    onDeployTeam?: () => void;
    onInspectTeam?: () => void;
    onBuildYourOwn?: () => void;
    onAllTeams?: () => void;
    entranceDelay?: number;
    entranceReady?: boolean;
    onAnimationEvent?: HeroCarouselControlsAnimationEventHandler;
    className?: string;
    style?: CSSProperties;
}
export function Cherocarouselcontrols({ onPrevious, onNext, onDeployTeam, onInspectTeam, onBuildYourOwn, onAllTeams, entranceDelay, entranceReady = true, onAnimationEvent, className, style, }: CherocarouselcontrolsProps): ReactElement {
    const { viewport } = useViewport();
    const controlsViewport = resolveHeroCarouselControlsViewport({ viewport });
    const controlsEntranceDelay = entranceDelay ?? CONTROLS_ANIMATION.delay;
    const shouldShowControls = entranceReady;
    const rootStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 24,
        pointerEvents: shouldShowControls ? 'auto' : 'none',
        ...style,
    };
    const topRowStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: TOP_ROW_GAP_BY_VIEWPORT[controlsViewport],
        flexWrap: 'nowrap',
        justifyContent: 'center',
    };
    return <div data-el="Cherocarouselcontrols/Root" style={rootStyle} className={className}>
            <div style={topRowStyle}>
                <CarouselArrowControl direction={CarouselArrowControlDirection.Previous} controlsViewport={controlsViewport} shouldShowControls={shouldShowControls} controlsEntranceDelay={controlsEntranceDelay} onClick={onPrevious} onAnimationEvent={onAnimationEvent}/>
                <DeployInspectControl controlsViewport={controlsViewport} shouldShowControls={shouldShowControls} controlsEntranceDelay={controlsEntranceDelay} onDeployTeam={onDeployTeam} onInspectTeam={onInspectTeam} onAnimationEvent={onAnimationEvent}/>
                <CarouselArrowControl direction={CarouselArrowControlDirection.Next} controlsViewport={controlsViewport} shouldShowControls={shouldShowControls} controlsEntranceDelay={controlsEntranceDelay} onClick={onNext} onAnimationEvent={onAnimationEvent}/>
            </div>

            <BuildAllControls controlsViewport={controlsViewport} shouldShowControls={shouldShowControls} controlsEntranceDelay={controlsEntranceDelay} onBuildYourOwn={onBuildYourOwn} onAllTeams={onAllTeams} onAnimationEvent={onAnimationEvent}/>
        </div>
        ;
}
